// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1hgPt","title":"styles_title__38S4h"};